import store from '@/store'

export const requiresAdmin = (to, _from, next) => {
  if ( !store.getters['auth/userIsAdmin'] ) {
    next({ path: '/home' })
  } else  {
    next()    
  }
}

export const requiresAuth = async (_to, _from, next) => {
  const isLoggedIn = store.getters['auth/signedIn']

  if ( isLoggedIn === false ) {
    next({ path: '/login' })
    return
  }

  if ( isLoggedIn === null ) {
    let result = await store.dispatch('auth/loadMe')
    if (!result.ok) {
      next({ path: '/login' })
    }
  }

  next()
}

export const logout = (_to, _from, next) => {
  store.dispatch('auth/logout')
  next({ name: 'login' })  
}
